import React from 'react'
import { getVersion } from 'util/version'

const VersionNumber = () => {
  return <div>v{getVersion()}</div>
}

export default VersionNumber
